<app-dashboard-v2 *ngIf="ready && isV2"></app-dashboard-v2>
<app-dashboard *ngIf="ready && !isV2"></app-dashboard>
<ngx-spinner color="rgba(30, 205, 100, 1)" type="ball-scale-multiple"></ngx-spinner>
